import { Injectable } from '@angular/core';

@Injectable()
export class NgProject {
	public constructor() {}
}
